export const COMPONENT_NAME = 'MarketingMessage';